import { logger } from '@gem/modules/logger';

import { IClientConfigProperty } from 'APP/model/auth/authModel.types';
import Entities from 'STORE';

export function handleWhitelistHosts(property: IClientConfigProperty): void {
  try {
    const whitelistHosts: string[] = JSON.parse(property.value);
    Entities.App.setWhitelistHosts(whitelistHosts);
  } catch (error) {
    logger.get('clientConfig').error('whitelist.urls', error);
  }
}
